// src/auth/AuthContext.js
import { createContext, useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { loginApi, logoutApi } from "../components/api/LoginApiService";
import { getCurrentUserApi } from "../components/api/UserApiService";
import { useLocation } from "react-router";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);      // aktif kullanıcı
  const [loading, setLoading] = useState(true); // uygulama açılırken / refresh
  const location = useLocation();

  useEffect(() => {
    // Login sayfasındayken backend'e kimim diye sorma
    if (location.pathname === "/authenticate") {
      setLoading(false);
      return;
    }

    getCurrentUserApi()
      .then((res) => setUser(res.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, [location.pathname]);

  // LOGIN: authenticate + /me + user state
  const login = async (credentials) => {
    await loginApi(credentials);         // cookie burada set edilir
    const res = await getCurrentUserApi();
    setUser(res.data);
    toast.success("Login successful");
  };

  const logout = async () => {
    try {
      await logoutApi();                  // backend cookie'yi siler
    } catch (e) {
      // logout başarısız bile olsa local state'i temizle
      console.error("Logout error", e);
    } finally {
      setUser(null);                      // frontend state'i temizle
      toast.success("Logged out");
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
